export const IconTelegram = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="56" height="56" rx="12" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.9613 29.5746L16.4019 27.5205C15.866 27.2466 15.866 26.4935 16.4019 26.2196L39.1084 17.3871C39.5772 17.1817 40.1131 17.5926 39.9791 18.1403L35.8933 38.1332C35.8263 38.6125 35.2905 38.8179 34.8886 38.544L29.3292 34.4359C28.9943 34.162 28.5254 34.162 28.1905 34.4359L25.1094 36.9692C24.7745 37.2431 24.2386 37.1061 24.1047 36.6269L21.9613 29.5746ZM34.5537 21.7007L23.7698 28.4791C23.3009 28.753 23.1669 29.2322 23.2339 29.8485L24.3726 34.0251C24.4396 34.2989 24.8415 34.2305 24.9084 33.9566L25.2433 31.6286C25.3103 31.1494 25.5113 30.7386 25.8462 30.4647L34.7546 21.9746C34.9555 21.8376 34.7546 21.5637 34.5537 21.7007Z"
      fill="white"
    />
  </svg>
);
